import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-emerald-500/15',
    borderColor: 'border-emerald-500/40',
    textColor: 'text-emerald-300',
    emoji: '📘',
    title: 'Fundamentos del Portugués para Argentinos',
    subtitle: 'El Sistema de Mapeo Rioplatense™',
    desc: 'Usa tu ventaja natural como hispanohablante. Pronunciación, primeras 200 frases, los errores fatales y cómo evitarlos desde el día 1.'
  }, {
    id: 2,
    lightColor: 'bg-green-700/15',
    borderColor: 'border-green-700/40',
    textColor: 'text-green-300',
    emoji: '📘',
    title: 'Portugués para Viajar a Brasil',
    subtitle: 'Todo lo que necesitás para tu viaje',
    desc: 'Aeropuertos, hoteles, restaurantes, transporte, compras y emergencias. Todo lo que necesitás decir antes, durante y después de tu viaje — sin usar el teléfono como traductor.'
  }, {
    id: 3,
    lightColor: 'bg-emerald-500/15',
    borderColor: 'border-emerald-500/40',
    textColor: 'text-emerald-300',
    emoji: '📘',
    title: 'Portugués Conversacional Real',
    subtitle: 'Cómo sonar natural en lugar de a libro de texto',
    desc: '120+ expresiones coloquiales, las 12 situaciones cotidianas más frecuentes, WhatsApp en portugués real y cómo sonar natural en lugar de sonar a libro de texto.'
  }, {
    id: 4,
    lightColor: 'bg-green-500/15',
    borderColor: 'border-green-500/40',
    textColor: 'text-green-300',
    emoji: '📘',
    title: 'Portugués para Trabajo y Negocios',
    subtitle: 'La cultura de negocios brasileña',
    desc: 'Entrevistas laborales, ventas, negociación, emails profesionales, reuniones y la cultura de negocios brasileña que necesitás entender para no perder tratos por errores culturales.'
  }, {
    id: 5,
    lightColor: 'bg-emerald-600/15',
    borderColor: 'border-emerald-600/40',
    textColor: 'text-emerald-300',
    emoji: '📘',
    title: 'Gramática Fácil para Argentinos',
    subtitle: 'Solo lo que importa, explicado desde el español',
    desc: 'Los 50 errores más frecuentes de los argentinos, el futuro del subjuntivo, POR vs PARA y los plurales de -ão que confunden a todos.'
  }, {
    id: 6,
    lightColor: 'bg-emerald-400/20',
    borderColor: 'border-emerald-400/50',
    textColor: 'text-emerald-300',
    emoji: '⭐',
    title: 'Portugués Fluido Nivel Intermedio',
    subtitle: 'El tomo que cierra el ciclo',
    desc: 'Los 8 fenómenos fonéticos del portugués hablado rápido, los 5 acentos regionales, cultura brasileña profunda y los 10 hábitos del hablante natural.'
  }];
  return <section className="py-20 bg-zinc-900" data-id="element-309">
      <div className="container mx-auto px-4" data-id="element-310">
        <div className="text-center mb-16" data-id="element-311">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-400/15 text-emerald-300 border border-emerald-400/30 font-bold mb-6 text-[16px]" data-id="element-312">
            🇧🇷 MEGAPACK PORTUGUÉS LISTO
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-313">
            6 Tomos + 4 Bonus
          </h2>
          <p className="text-zinc-200 font-medium text-[16px]" data-id="element-314">
            500+ páginas · Todo resuelto para argentinos
          </p>
          <p className="text-emerald-300 font-medium text-sm mt-2" data-id="element-315">
            📚 Un tomo por cada dimensión del aprendizaje
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-316">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-emerald-900/40 bg-black/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-emerald-700/60 transition-all flex flex-col h-full" data-id="element-317">
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-318">
                <div className="text-2xl" data-id="element-319">{tomo.emoji}</div>
                <div data-id="element-320">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-321">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-322">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-323">
                <p className="font-semibold text-emerald-200 mb-3 pb-3 border-b border-emerald-900/30" data-id="element-324">
                  {tomo.subtitle}
                </p>
                <p className="text-zinc-200 text-sm leading-relaxed" data-id="element-325">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}